import type { UsageMetadata } from '@avisoma/shared/dist/ProcessingData';

/**
 * Standard API list prices for text-embedding-3-* (input tokens), USD per 1M tokens.
 * @see https://platform.openai.com/docs/pricing
 */
export const TEXT_EMBEDDING_3_LARGE_USD_PER_MILLION_INPUT = 0.13;
export const TEXT_EMBEDDING_3_SMALL_USD_PER_MILLION_INPUT = 0.02;

/** Document pipeline uses `text-embedding-3-large` for page embeddings. */
export function estimateTextEmbedding3LargeUsd(usage: UsageMetadata): number {
  const inputTokens = usage.promptTokenCount ?? usage.totalTokenCount ?? 0;
  return inputTokens * (TEXT_EMBEDDING_3_LARGE_USD_PER_MILLION_INPUT / 1_000_000);
}
